import LocalStorageService from '@application/common/local-storage-service';
import { config } from '@application/common/static-config';
import { logout } from '@application/features/auth/authSlice';
import { refreshTokenAsync } from '@application/features/auth/authThunk';
import i18n from '@application/utilities/i18n';
import publicRoutes from '@ui/routes/PublicRoutes';
import axios from 'axios';
import { toast } from 'react-toastify';
const { baseURL } = config;
let refreshing_token = null;
export const vdkEmHappinessPortalApi = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json'
    }
});
vdkEmHappinessPortalApi.interceptors.request.use(async (config) => {
    const isPublicRoute = publicRoutes.some((publicPath) => config.url?.toLowerCase().includes(publicPath.toLowerCase()));
    const { store } = await import('@application/store');
    const state = store.getState();
    const selectedCompanyId = state.company.selectedCompanyId;
    const companyId = selectedCompanyId;
    if (config.headers && typeof config.headers.set == 'function') {
        config.headers.set('Accept-Language', i18n.language || 'en');
        config.headers.set('PayloadCompanyId', companyId.length ? companyId.join(',') : '');
    }
    const accessToken = LocalStorageService.getAccessToken();
    const msAccessToken = LocalStorageService.getMSAccessToken();
    if (accessToken == null && !isPublicRoute && config.url != 'auth/refreshToken') {
        // Only logout if we're not in the middle of a refresh token request
        if (!refreshing_token) {
            const { store } = await import('@application/store');
            store.dispatch(logout());
        }
        const controller = new AbortController();
        const cfg = {
            ...config,
            signal: controller.signal
        };
        controller.abort('No access token available');
        return cfg;
    }
    if (config.url != 'auth/refreshToken' && config.url != 'auth/token') {
        if (config.headers) {
            config.headers.set('Authorization', `Bearer ${msAccessToken}`);
            config.headers.set('XAuthorization', `Bearer ${accessToken}`);
        }
    }
    return config;
});
vdkEmHappinessPortalApi.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    const config = error.config;
    // Handle rate limiting (429 Too Many Requests)
    if (error.response && error.response.status === 429) {
        const errorMessage = error.response.data?.error || 'API rate limit exceeded. Please try again later.';
        toast.warning(errorMessage);
        return Promise.reject(error);
    }
    if (error.response && error.response.status == 401 && !config._retry) {
        if (error.config.url == 'auth/token' || error.config.url == 'account/forget-password') {
            return Promise.reject(error);
        }
        else if (error.config.url == 'auth/refreshToken' || error.config.retry) {
            const { store } = await import('@application/store');
            store.dispatch(logout());
            window.location.replace('/login');
        }
        else {
            config._retry = true;
            try {
                // refreshing_token = refreshing_token ? refreshing_token : refreshToken();
                // await refreshing_token;
                const { accessToken, msAccessToken } = await refreshToken(); //always await the shared promise
                if (config.headers) {
                    config.headers.set('Authorization', `Bearer ${msAccessToken}`);
                    config.headers.set('XAuthorization', `Bearer ${accessToken}`);
                }
                return vdkEmHappinessPortalApi(config);
            }
            catch (err) {
                config._retry = false;
                const { store } = await import('@application/store');
                refreshing_token = null;
                store.dispatch(logout());
            }
            finally {
                refreshing_token = null;
            }
        }
    }
    refreshing_token = null;
    return Promise.reject(error);
});
async function refreshToken() {
    if (!refreshing_token) {
        const { store } = await import('@application/store');
        refreshing_token = store
            .dispatch(refreshTokenAsync())
            .unwrap()
            .catch((error) => {
            refreshing_token = null;
            store.dispatch(logout());
            window.location.replace('/login');
            throw error;
        })
            .then((result) => {
            refreshing_token = null;
            return result;
        });
    }
    return refreshing_token;
}
